import { ContactCard } from "../components/ContactCard";
import { FaqList } from "../components/FaqList";
import { SiteLayout } from "../components/SiteLayout";
import { seoByLocale, supportByLocale } from "../content";
import type { Locale } from "../content/types";
import { usePageSeo } from "../lib/seo";

type SupportPageProps = {
  locale: Locale;
};

export function SupportPage({ locale }: SupportPageProps) {
  const support = supportByLocale[locale];
  usePageSeo({ locale, routeKind: "support", seo: seoByLocale[locale].support });

  // FAQ 结构化数据：复用页面问答内容，随预渲染输出，便于搜索引擎与 AI 抽取。
  const faqJsonLd = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: support.faqs.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: { "@type": "Answer", text: item.answer }
    }))
  });

  return (
    <SiteLayout locale={locale} page="support">
      <div className="support-page">
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: faqJsonLd }} />
        <section className="support-intro">
          <h1>{support.title}</h1>
          <h2>{support.introTitle}</h2>
          <p>{support.introBody}</p>
        </section>

        <FaqList title={support.faqHeading} items={support.faqs} />

        <div className="support-followup">
          <ContactCard heading={support.contactHeading} description={support.contactDescription} email={support.email} />

          <section className="support-section support-detail-card">
            <h2>{support.reportHeading}</h2>
            <ul>
              {support.reportItems.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </section>
        </div>
      </div>
    </SiteLayout>
  );
}
